import {
  type MouseEventHandler,
  type PropsWithChildren,
  forwardRef,
} from "react";

import type { TableRowCheckboxProps } from "./TableRowCheckbox.types";
import { Checkbox } from "../../atoms";

const TableRowCheckbox = forwardRef<
  HTMLDivElement,
  PropsWithChildren<TableRowCheckboxProps>
>(({ row, table, lastSelectedRow, handleSetLastSelectedRow }) => {
  const handleCheckboxClick: MouseEventHandler<HTMLInputElement> = (e) => {
    e.stopPropagation();

    if (e.shiftKey) {
      const { rows } = table.getRowModel();
      const lastSelectedIndex = lastSelectedRow.index;
      const isCurrentRowSelected = row.getIsSelected();

      if (lastSelectedIndex >= 0) {
        const [minIndex, maxIndex] =
          lastSelectedIndex < row.index
            ? [lastSelectedIndex, row.index]
            : [row.index, lastSelectedIndex];

        for (const row of rows) {
          if (row.index >= minIndex && row.index <= maxIndex) {
            row.toggleSelected(!isCurrentRowSelected);
          }
        }
      }
    }
  };

  const handleCustomChange = () => {
    const isSelected = row.getIsSelected();
    row.toggleSelected();
    handleSetLastSelectedRow(row.index, isSelected);
  };

  return (
    <div className="ml-4">
      <Checkbox
        className="size-4 hover:cursor-pointer"
        checked={row.getIsSelected()}
        onChange={handleCustomChange}
        onClick={handleCheckboxClick}
      />
    </div>
  );
});

TableRowCheckbox.displayName = "TableRowCheckbox";

export default TableRowCheckbox;
